/* eslint-disable import/no-default-export */
import React, { ButtonHTMLAttributes } from 'react';

import classNames from 'classnames';

import styles from './PrimaryButton.less';

type PrimaryButtonProps = React.DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export const PrimaryButton: React.FunctionComponent<PrimaryButtonProps> = ({
  className = '',
  ...props
}) => (
  <button className={classNames(styles.primaryButton, className)} {...props} />
);
